import {BreadcrumbType, Card} from 'platform/components';

import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {AddGdprConsentTypeForm} from './components/AddGdprConsentTypeForm';

export function AddNewGdprConsentType() {
  const breadcrumbs: BreadcrumbType[] = [
    {
      label: i18n.t('entity.gdpr.labels.gdprConsentTypes'),
      href: settingsRoutes.gdprConsentTypes,
    },
  ];

  return (
    <SettingsTemplate header={{breadcrumbs}} data-testid="add-gdpr-consent-type-page">
      <Card title={i18n.t('page.settings.labels.newConsentType')}>
        <AddGdprConsentTypeForm cancelRoute={settingsRoutes.gdprConsentTypes} />
      </Card>
    </SettingsTemplate>
  );
}
